import React from 'react';

import {isUhcEnabled} from 'libs/rollout';

import {BADGES_TITLES_CART, SALE_BADGES} from '../../constants/badges';

import {Badge, BADGE_SIZE} from '../badge';

import {BadgeRedesign} from '../badge/redesign/badgeRedesign';

import s from './cartItemBadges.scss';

export type BadgeType = {
    code: keyof typeof BADGES_TITLES_CART;
    title: string;
};

type PropsType = {
    badges?: Array<BadgeType>;
};

/**
 * Badges for cart item
 * @param {PropsType} props for component
 * @returns {Node} badges
 */
export const CartItemBadges = React.memo<PropsType>(({badges = []}) => (
    <div className={s.wrapper}>
        {badges.map((badge: BadgeType) => {
            if (!BADGES_TITLES_CART[badge.code]) return null;
            if (SALE_BADGES.includes(badge.code) && isUhcEnabled()) return null;

            const id = BADGES_TITLES_CART[badge.code];
            return (
                <div className={s.item} key={id}>
                    <BadgeRedesign id={id}>
                        <Badge id={id} size={BADGE_SIZE.MEDIUM} />
                    </BadgeRedesign>
                </div>
            );
        })}
    </div>
));

CartItemBadges.displayName = 'CartItemBadges';
